var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),(_vm.hashChanged && _vm.isProd)?_c('new-version-modal',{on:{"close":function($event){_vm.hashChanged = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }